import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsPerformanceDashboardRoute: InvariantJiraRoute = {
	name: 'global-settings-performance-dashboard',
	path: '/jira/settings/system/performance/dashboard',
};
